import React, { useEffect } from "react";
import HighlightText from '../components/core/HomePage/HighlightText';
import AOS from 'aos';
import 'aos/dist/aos.css';
import CareerHero from '../assets/career-hero.jpeg'; // You'll need to add this image
import Footer from "../components/common/Footer";

const Careers = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
    AOS.refresh();
  }, []);

  return (
    <div className="bg-richblue-5 text-richblue-700">
      {/* Hero Section */}
      <section className="bg-richblue-5 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src={CareerHero} alt="Career opportunities" className="w-full h-full object-cover" />
        </div>
        <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col justify-between py-20 text-center">
          <header data-aos="fade-up" className="mx-auto text-4xl font-semibold lg:w-[70%] text-richblue-700">
            Join Our <HighlightText text={"Team"} /> and Shape the Future
            <p className="mx-auto mt-6 text-center text-base font-medium text-richblue-500 lg:w-[90%]">
              Be part of a community dedicated to empowering professionals in Artificial Intelligence, Project Management, and Service Management
            </p>
          </header>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="mx-auto w-11/12 max-w-maxContent">
          {/* Introduction */}
          <div data-aos="fade-up" className="mb-16">
            <p className="text-richblue-500 mb-8 text-lg leading-relaxed">
              At Mavens Technology Solutions, we are more than just a training organization; we are a community dedicated to empowering professionals and shaping the future of Artificial Intelligence, Project Management, and Service Management. As an Accredited Training Organization (ATO), we offer transformative learning experiences, and we are always on the lookout for passionate, talented individuals who share our commitment to excellence and professional growth.
            </p>
          </div>

          {/* Why Work With Us */}
          <div data-aos="fade-up" className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-richblue-700">Why Work with <HighlightText text={"Us"} />?</h2>
            <p className="text-richblue-500 mb-6">
              Joining Mavens Technology Solutions means becoming part of a forward-thinking, innovative team that thrives on collaboration, creativity, and the pursuit of continuous improvement. We provide an inclusive work environment that supports your personal and professional growth.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg">
                <h3 className="text-xl font-semibold mb-3 text-richblue-600">Empowering Education</h3>
                <p className="text-richblue-500">Play a vital role in shaping the careers of professionals by delivering world-class training programs.</p>
              </div>
              
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg">
                <h3 className="text-xl font-semibold mb-3 text-richblue-600">Dynamic Culture</h3>
                <p className="text-richblue-500">Work with industry experts, constantly evolving in the fields of AI, Project Management, and Service Management.</p>
              </div>
              
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg">
                <h3 className="text-xl font-semibold mb-3 text-richblue-600">Professional Growth</h3>
                <p className="text-richblue-500">Benefit from ongoing learning opportunities, certifications, and career development programs.</p>
              </div>
              
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg">
                <h3 className="text-xl font-semibold mb-3 text-richblue-600">Collaborative Environment</h3>
                <p className="text-richblue-500">Be part of a team that values your insights and fosters a culture of mutual respect, innovation, and teamwork.</p>
              </div>
            </div>
          </div>

          {/* Current Openings */}
          <div data-aos="fade-up" className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-richblue-700">Current <HighlightText text={"Openings"} /></h2>
            <p className="text-richblue-500 mb-8">
              We are constantly looking for exceptional individuals who can bring their expertise, passion, and dedication to our organization. Explore the current job openings below:
            </p>

            <div className="space-y-6">
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg transition-all duration-300 hover:bg-richblue-25">
                <h3 className="text-xl font-semibold text-richblue-600 mb-2">AI Course Trainer</h3>
                <p className="text-richblue-500">Are you an expert in Artificial Intelligence, machine learning, or data science? Join our AI training team and inspire the next generation of innovators.</p>
                <button className="mt-4 px-5 py-2 bg-richblue-200 hover:bg-richblue-300 text-richblue-900 rounded-md text-sm font-medium">View Details</button>
              </div>
              
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg transition-all duration-300 hover:bg-richblue-25">
                <h3 className="text-xl font-semibold text-richblue-600 mb-2">Project Management Trainer</h3>
                <p className="text-richblue-500">If you have in-depth knowledge of Project Management frameworks such as Agile, Scrum, PRINCE2, or PMP, and a passion for teaching, we want you to share your expertise with aspiring project leaders.</p>
                <button className="mt-4 px-5 py-2 bg-richblue-200 hover:bg-richblue-300 text-richblue-900 rounded-md text-sm font-medium">View Details</button>
              </div>
              
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg transition-all duration-300 hover:bg-richblue-25">
                <h3 className="text-xl font-semibold text-richblue-600 mb-2">Service Management Trainer</h3>
                <p className="text-richblue-500">Are you experienced in IT service management frameworks like ITIL, COBIT, or Lean? Help organizations improve service delivery and empower professionals with the best practices in service management.</p>
                <button className="mt-4 px-5 py-2 bg-richblue-200 hover:bg-richblue-300 text-richblue-900 rounded-md text-sm font-medium">View Details</button>
              </div>
              
              <div className="bg-richblue-5 p-6 rounded-xl shadow-lg transition-all duration-300 hover:bg-richblue-25">
                <h3 className="text-xl font-semibold text-richblue-600 mb-2">Customer Success Manager</h3>
                <p className="text-richblue-500">Guide our students through their learning journey, providing support and ensuring they have the resources to succeed in their training programs.</p>
                <button className="mt-4 px-5 py-2 bg-richblue-200 hover:bg-richblue-300 text-richblue-900 rounded-md text-sm font-medium">View Details</button>
              </div>
            </div>
          </div>

          {/* Internships */}
          <div data-aos="fade-up" className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-richblue-700">Internships for <HighlightText text={"Emerging Talent"} /></h2>
            <div className="bg-richblue-5 p-8 rounded-xl shadow-lg">
              <p className="text-richblue-500 leading-relaxed">
                We believe in nurturing the next generation of talent! Our internship program offers hands-on experience in a real-world setting, with the opportunity to work alongside seasoned professionals and contribute to impactful projects. Whether you're exploring AI, project management, or service management, this is a fantastic chance to gain valuable experience while learning from the best.
              </p>
              <button className="mt-6 px-6 py-3 bg-yellow-50 text-richblack-900 rounded-md hover:bg-yellow-100 transition-all duration-300 font-medium">Apply for Internship</button>
            </div>
          </div>

          {/* Training & Development */}
          <div data-aos="fade-up" className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-richblue-700">Training & Development: <HighlightText text={"Your Growth is Our Priority"} /></h2>
            <p className="text-richblue-500 mb-8 leading-relaxed">
              At Mavens Technology Solutions, we value continuous learning and development, and we are committed to helping our team members grow professionally. From obtaining industry-recognized certifications to participating in exclusive training workshops, we provide all the tools you need to advance in your career. With us, you will be equipped with the knowledge to stay ahead of industry trends and make meaningful contributions to your field.
            </p>
          </div>

          {/* How to Apply */}
          <div data-aos="fade-up" className="bg-richblue-5 p-8 rounded-xl shadow-lg mb-16">
            <h2 className="text-3xl font-bold mb-6">How to <HighlightText text={"Apply"} /></h2>
            <p className="text-richblue-500 mb-6 leading-relaxed">
              We want to hear from you! If you're passionate about education, innovation, and making a difference, send us your resume along with a cover letter that highlights your experience, why you're a great fit for the role, and your commitment to empowering others.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-4 mt-8">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="w-full md:w-auto flex-grow px-4 py-3 bg-richblue-100 text-richblue-900 rounded-md focus:outline-none focus:ring-2 focus:ring-richblue-400"
              />
              <button className="w-full md:w-auto px-6 py-3 bg-richblue-400 text-white rounded-md hover:bg-richblue-500 transition-all duration-300 font-medium">
                Send Application
              </button>
            </div>
            <p className="text-richblue-500 mt-4">
              Or email your application to: <span className="text-richblue-600">mavenstechsolutions@gmail.com</span>
            </p>
          </div>

          {/* Closing */}
          <div data-aos="fade-up" className="text-center">
            <p className="text-xl text-richblue-500">
              We are always eager to welcome new team members who share our vision of transforming the world of professional training. Join us today and help shape the future of AI, Project Management, and Service Management education!
            </p>
            <div className="mt-8 flex justify-center">
              <button className="px-8 py-4 bg-richblue-400 text-white rounded-md hover:bg-richblue-500 transition-all duration-300 font-semibold text-lg">
                View All Opportunities
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default Careers;